module.exports = __webpack_public_path__ + "assets/ce9e0e13704a92eed950db153a6f893b.png";